import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import * as main from '@shared/styles/abstracts/vars.module.scss';
import { Card } from '@shared/ui/index';

export const SCard10 = styled(Card)`
  padding: 10px;
`;
export const SCardWithTransition10 = styled(SCard10)`
  transition: transform 300ms ease-in-out;
  &:hover {
    transform: scale(1.01);
    cursor: pointer;
  }
`;
export const SLink = styled(Link)`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: center;
`;

export const STextOverflowCss = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const SPosAbs = styled.div`
  position: absolute;
`;
export const SDF = styled.div`
  display: flex;
`;
export const SDisplayFLexC = styled(SDF)`
  flex-direction: column;
`;
export const SDisplayFLexR = styled(SDF)`
  flex-direction: row;
`;
export const SMagicBox = styled.div<{
  $shouldHideOnMobile?: boolean;
  $shouldHideOnMobileL?: boolean;
  $shouldHideOnTablet?: boolean;
  $shouldHideOnLaptop?: boolean;
  $shouldHideOnLaptopL?: boolean;
  $shouldHideOn4k?: boolean;
  $shouldHide?: boolean;
}>`
  ${(p) => p.$shouldHide && `display: none;`}

  ${(p) =>
    p.$shouldHideOnMobile &&
    `@media screen and (max-width: ${main.brpMobile}) {
        				display: none;
				    }`}

    ${(p) =>
    p.$shouldHideOnMobileL &&
    `@media screen and (max-width: ${main.brpMobileL}) {
        				display: none;
				    }`}

    ${(p) =>
    p.$shouldHideOnTablet &&
    `@media screen and (max-width: ${main.brpTablet}) {
        				display: none;
				    }`}

    ${(p) =>
    p.$shouldHideOnLaptop &&
    `@media screen and (max-width: ${main.brpLaptop}) {
        				display: none;
				    }`}

    ${(p) =>
    p.$shouldHideOnLaptopL &&
    `@media screen and (max-width: ${main.brpLaptopL}) {
        				display: none;
				    }`}

    ${(p) =>
    p.$shouldHideOn4k &&
    `@media screen and (max-width: ${main.brp4k}) {
        				display: none;
				    }`}
`;
